import * as Yup from 'yup';
import {
  lessThanXCharsNotEndBacklashRequired,
  numberBetweenXAndY,
} from '../../../helpers/validationSchemaHelpers';

export const nameValidationSchema = lessThanXCharsNotEndBacklashRequired('name', 20);
export const descriptionValidationSchema = lessThanXCharsNotEndBacklashRequired('description', 50);
export const itemDiscountLimitValidationSchema = numberBetweenXAndY(
  'discountOptsItemDiscountLimit',
  0,
  9999999
);

export const itemDiscountLimitPercentValidationSchema = numberBetweenXAndY(
  'discountOptsItemDiscountLimitPct',
  0,
  100
);

export const basketDiscountLimitValidationSchema = numberBetweenXAndY(
  'discountOptsBasketDiscountLimit',
  0,
  9999999
);

export const basketDiscountLimitPercentValidationSchema = numberBetweenXAndY(
  'discountOptsBasketDiscountLimitPct',
  0,
  100
);

export const refundLimitValidationSchema = numberBetweenXAndY(
  'discountOptsRefundLimit',
  0,
  9999999
);
export const maxCreditLimitValidationSchema = numberBetweenXAndY(
  'customerOptsCreditLimit',
  0,
  9999999
);

const validationSchema = Yup.object({
  globalTillAccess: Yup.boolean(),
  adminOptsTillAdmin: Yup.boolean(),
  adminOptsTillSettings: Yup.boolean(),
  adminOptsBackOffice: Yup.boolean(),
  adminOptsQuickAdd: Yup.boolean(),
  adminOptsManagerOverride: Yup.boolean(),
  adminOptsPettyCash: Yup.boolean(),
  adminOptsFloatAdjust: Yup.boolean(),
  adminOptsNoSale: Yup.boolean(),
  adminOptsTillClosing: Yup.boolean(),
  adminOptsTillClosing_BlindEOD: Yup.boolean(),
  adminOptsTipOutSelf: Yup.boolean(),
  adminOptsTipOutOthers: Yup.boolean(),
  adminOptsCanWaiterBank: Yup.boolean(),
  discountOptsItemDiscount: Yup.boolean(),
  discountOptsBasketDiscount: Yup.boolean(),
  discountOptsRefunds: Yup.boolean(),
  transactionOptsPayouts: Yup.boolean(),
  transactionOptsVoidLine: Yup.boolean(),
  transactionOptsVoidUnordered: Yup.boolean(),
  transactionOptsClear: Yup.boolean(),
  transactionOptsTablePlanning: Yup.boolean(),
  transactionOptsRemoveFromTable: Yup.boolean(),
  transactionOptsDisableServiceCharge: Yup.boolean(),
  transactionOptsHold: Yup.boolean(),
  transactionOptsChangeTabSpendLimit: Yup.boolean(),
  transactionOptsCreateMiscProducts: Yup.boolean(),
  customerOptsCustomerSelect: Yup.boolean(),
  adminOptsCustomerList: Yup.boolean(),
  customerOptsEditCustomerPoints: Yup.boolean(),
  stockOptsStockSend: Yup.boolean(),
  stockOptsStockReceive: Yup.boolean(),
  stockOptsStockTake: Yup.boolean(),
  stockOptsUnrestrictedStockTake: Yup.boolean(),
})
  .concat(nameValidationSchema)
  .concat(descriptionValidationSchema)
  .concat(itemDiscountLimitValidationSchema)
  .concat(itemDiscountLimitPercentValidationSchema)
  .concat(basketDiscountLimitValidationSchema)
  .concat(basketDiscountLimitPercentValidationSchema)
  .concat(refundLimitValidationSchema)
  .concat(maxCreditLimitValidationSchema);

export default validationSchema;
